  <template>
  <div>

    <v-container>

      <v-row>
        <v-col md="3">
          <KTCard title="ذخیره سازی">


            <template #title>
              <div class="d-flex align-items-center">
                <span class="flaticon2-check-mark mr-3 font-size-h4"></span>
                <h4>ذخیره سازی</h4>
              </div>
            </template>

            <template #body>
              <b-row>
                <b-col md="6" class="py-0">
                  <b-button class="d-flex align-items-center w-100 justify-content-center">
                    <b-icon-x-circle/>
                    <span class="ml-4 font-size-h5">لغو</span>
                  </b-button>
                </b-col>
                <b-col md="6" class="py-0">
                  <b-button variant="success" class="d-flex align-items-center w-100 justify-content-center">
                    <b-icon-check-circle/>
                    <span class="ml-4 font-size-h5">تایید</span>
                  </b-button>
                </b-col>
                <b-col md="6"></b-col>
              </b-row>
            </template>
          </KTCard>
          <KTCard title="تصویر" >

            <template #title>
              <div class="d-flex align-items-center">
                <span class="flaticon2-photograph mr-3 font-size-h4"></span>
                <h4>تصویر</h4>
              </div>
            </template>

            <template #body>

              <div class="d-flex justify-content-center flex-column">
                <img class="w-100" src="https://app.digitalserver.ir/images/p/300x300/de931563-57ce-49a7-9e40-0b3eb940b2b2.JPG" alt="">
              </div>

              <b-button class="d-flex align-items-center mx-auto mt-5">
                <span class="flaticon2-photograph mr-2"></span>
                <span>آپلود تصویر</span>
              </b-button>


            </template>

          </KTCard>
          <KTCard title="تنظیمات">

            <template #title>
              <div class="d-flex align-items-center">
                <span class="flaticon-cogwheel-2 mr-3 font-size-h4"></span>
                <h4>تنظیمات</h4>
              </div>
            </template>

            <template #body>
              <div class="d-flex align-items-center">
                <label class="mr-3 mb-0 font-weight-bold font-size-h5">وضعیت ( فعال / غیر فعال ) :</label>
                <span dir="ltr" class="">
                  <b-form-checkbox size="lg" switch/>
                </span>
              </div>
            </template>

          </KTCard>
        </v-col>
        <v-col md="9">
          <KTCard title="اطلاعات">
            <template #title>
              <div class="d-flex align-items-center">
                <span class="flaticon2-information mr-3 font-size-h4"></span>
                <h4>اطلاعات</h4>
              </div>
            </template>


            <template #body>
              <b-row>
                <b-col md="6">
                  <label class="font-weight-bold">عنوان : <span class="text-danger">*</span></label>
                  <b-form-input type="text" placeholder="عنوان گروه"/>
                </b-col>
                <b-col md="6">
                  <label class="font-weight-bold">گروه : </label>
                  <b-form-select>
                    <b-form-select-option value="0">بدون گروه</b-form-select-option>
                    <b-form-select-option value="1">گروه 1</b-form-select-option>
                    <b-form-select-option value="2">گروه 2</b-form-select-option>
                    <b-form-select-option value="3">گروه 3</b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>
            </template>

          </KTCard>
          <KTCard title="پیشرفته">
            <template #title>
              <div class="d-flex align-items-center">
                <span class="flaticon-more mr-3 font-size-h4"></span>
                <h4>پیشرفته</h4>
              </div>
            </template>


            <template #body>
              <b-row>
                <b-col md="6">
                  <label class="font-weight-bold">کلاس استایل آیکون : </label>
                  <b-form-input type="text" placeholder="کلاس استایل آیکون"/>
                </b-col>
                <b-col md="6">
                  <label class="font-weight-bold">کلاس استایل رنگ : </label>
                  <b-form-input type="text" placeholder="کلاس استایل رنگ"/>
                </b-col>
                <b-col md="6">
                  <label class="font-weight-bold">برچسب ها : </label>
                  <b-form-input type="text" placeholder="برچسب ها"/>
                </b-col>
                <b-col md="6">
                  <label class="font-weight-bold">آدرس یکت : </label>
                  <b-form-input type="text" placeholder="آدرس یکت"/>
                </b-col>
              </b-row>
            </template>

          </KTCard>
        </v-col>
      </v-row>

    </v-container>

  </div>
</template>

<script>
import KTCard from "../../content/Card";
export default {
  name: "Create",
  components: {KTCard}
}
</script>

<style scoped>

</style>
